// Theme entry point. Native Shopify cart AJAX + Section Rendering API.

const cartDrawer = document.getElementById('cart-drawer');

function openCartDrawer() {
  if (cartDrawer && typeof cartDrawer.showModal === 'function') {
    cartDrawer.showModal();
  }
}

function closeCartDrawer() {
  if (cartDrawer && cartDrawer.open) {
    cartDrawer.close();
  }
}

async function refreshCartDrawer() {
  if (!cartDrawer) return;
  const response = await fetch(`${window.Shopify.routes.root}?section_id=cart-drawer`);
  const text = await response.text();
  const html = new DOMParser().parseFromString(text, 'text/html');
  const nextItems = html.querySelector('[data-cart-items]');
  const currentItems = cartDrawer.querySelector('[data-cart-items]');
  if (nextItems && currentItems) {
    currentItems.innerHTML = nextItems.innerHTML;
  }
}

async function refreshCartCount() {
  const response = await fetch(`${window.Shopify.routes.root}cart.js`);
  const cart = await response.json();
  document.querySelectorAll('[data-cart-count]').forEach((el) => {
    el.textContent = cart.item_count;
    el.hidden = cart.item_count === 0;
  });
}

async function changeCartLine(line, quantity, wrapper) {
  // quantity 0 removes the line. A 422 means the requested quantity exceeds
  // available stock; Shopify caps the line at what it can fulfil, so we just
  // refresh to show the corrected quantity — no alert.
  // Dim the line's controls while the request is in flight; a successful
  // refresh replaces the markup, and the finally re-enables on error.
  if (wrapper) wrapper.classList.add('is-loading');
  try {
    await fetch(`${window.Shopify.routes.root}cart/change.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line, quantity: Math.max(0, quantity) }),
    });
    await Promise.all([refreshCartDrawer(), refreshCartCount()]);
  } finally {
    if (wrapper) wrapper.classList.remove('is-loading');
  }
}

// Cart drawer open/close + line removal / quantity wiring
document.addEventListener('click', (event) => {
  if (event.target.closest('[data-cart-toggle]')) {
    event.preventDefault();
    openCartDrawer();
  }
  if (event.target.closest('[data-cart-close]')) {
    closeCartDrawer();
  }
  const remove = event.target.closest('[data-cart-remove]');
  if (remove) {
    // AJAX remove by line index so the drawer updates in place instead of
    // navigating to /cart/change (which errors without a valid line/id).
    event.preventDefault();
    const line = parseInt(remove.getAttribute('data-cart-remove'), 10);
    const wrapper = remove.closest('.cart-drawer-line');
    if (line) changeCartLine(line, 0, wrapper);
  }
  // Cart-line quantity steppers: mirror the product page, but stepping to 0
  // removes the line (no disabled-at-1). The line index lives on the wrapper.
  const step = event.target.closest('[data-cart-qty-minus], [data-cart-qty-plus]');
  if (step) {
    event.preventDefault();
    if (step.disabled || step.closest('.is-loading')) return;
    const wrapper = step.closest('[data-line]');
    const input = wrapper && wrapper.querySelector('[data-cart-qty-input]');
    if (!wrapper || !input) return;
    const line = parseInt(wrapper.getAttribute('data-line'), 10);
    const current = parseInt(input.value, 10) || 0;
    const delta = step.hasAttribute('data-cart-qty-plus') ? 1 : -1;
    if (line) changeCartLine(line, current + delta, wrapper);
  }
});

// Close when clicking the backdrop
if (cartDrawer) {
  cartDrawer.addEventListener('click', (event) => {
    if (event.target === cartDrawer) closeCartDrawer();
  });
}

// Menu drawer: mobile-only navigation
const menuDrawer = document.getElementById('menu-drawer');
const menuToggle = document.querySelector('[data-menu-toggle]');
const desktopQuery = window.matchMedia('(min-width: 800px)');

function setMenuExpanded(expanded) {
  if (menuToggle) menuToggle.setAttribute('aria-expanded', String(expanded));
}

function openMenuDrawer() {
  if (menuDrawer && typeof menuDrawer.showModal === 'function') {
    menuDrawer.showModal();
    setMenuExpanded(true);
  }
}

function closeMenuDrawer() {
  if (menuDrawer && menuDrawer.open) {
    menuDrawer.close();
  }
}

if (menuDrawer) {
  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-menu-toggle]')) {
      event.preventDefault();
      openMenuDrawer();
    }
    if (event.target.closest('[data-menu-close]')) {
      closeMenuDrawer();
    }
  });

  menuDrawer.addEventListener('click', (event) => {
    if (event.target === menuDrawer) closeMenuDrawer();
  });

  // Covers Esc and every other native close path
  menuDrawer.addEventListener('close', () => setMenuExpanded(false));

  // The toggle is hidden above the breakpoint; a drawer left open would trap focus
  desktopQuery.addEventListener('change', (event) => {
    if (event.matches) closeMenuDrawer();
  });
}
// Variant picker: keep the hidden id, price, and button in sync
function initProductForm() {
  const product = document.querySelector('[data-product]');
  if (!product) return;

  const variantsScript = document.querySelector('[data-product-variants]');
  const variants = variantsScript
    ? JSON.parse(variantsScript.textContent)
    : [];

  const form = product.querySelector('form[action*="/cart/add"]');
  const variantIdInput = product.querySelector('[data-variant-id]');
  const addButton = product.querySelector('[data-add-button]');
  const addButtonText = product.querySelector('[data-add-button-text]');
  const priceCurrent = product.querySelector('.price-current');

  // Gallery: a horizontal scroll-snap track of one slide per media item. The
  // option flagged by the section (the colour) drives it: picking a value
  // scrolls to that colorway's image, and swiping to an image picks its value.
  const galleryTrack = product.querySelector('[data-gallery-track]');
  const gallerySlides = galleryTrack
    ? Array.from(galleryTrack.querySelectorAll('[data-media-id]'))
    : [];
  const galleryOptionIndex = parseInt(
    product.getAttribute('data-gallery-option'),
    10
  );
  const hasGalleryOption =
    Number.isInteger(galleryOptionIndex) && galleryOptionIndex >= 0;
  const reducedMotion = window.matchMedia(
    '(prefers-reduced-motion: reduce)'
  );

  function selectedOptions() {
    return Array.from(
      product.querySelectorAll('.product-option-input:checked')
    ).map((input) => input.value);
  }

  function findVariant(options) {
    return variants.find((variant) =>
      variant.options.every(
        (option, index) => option === options[index]
      )
    );
  }

  function isPreorderVariant(variant) {
    return (
      variant &&
      variant.available === true &&
      variant.inventory_policy === 'continue' &&
      Number(variant.inventory_quantity) <= 0
    );
  }

  // Which slide is (mostly) on screen right now.
  function currentSlideIndex() {
    if (!galleryTrack || gallerySlides.length === 0) return -1;
    const centre = galleryTrack.scrollLeft + galleryTrack.clientWidth / 2;
    let best = 0;
    let bestDistance = Infinity;
    gallerySlides.forEach((slide, index) => {
      const slideCentre = slide.offsetLeft + slide.offsetWidth / 2;
      const distance = Math.abs(slideCentre - centre);
      if (distance < bestDistance) {
        bestDistance = distance;
        best = index;
      }
    });
    return best;
  }

  function scrollToSlide(index, behavior) {
    if (!galleryTrack || index < 0 || index >= gallerySlides.length) return;
    if (index === currentSlideIndex()) return;
    galleryTrack.scrollTo({
      left: gallerySlides[index].offsetLeft,
      behavior: reducedMotion.matches ? 'auto' : behavior || 'smooth',
    });
  }

  function slideIndexForMedia(mediaId) {
    if (mediaId === null || mediaId === undefined) return -1;
    return gallerySlides.findIndex(
      (slide) => slide.getAttribute('data-media-id') === String(mediaId)
    );
  }

  // The image for the currently picked colour: the first variant carrying that
  // colour with an image of its own. Falls back to the exact variant's image
  // when the product has no colour option.
  function mediaIdForSelection(variant) {
    if (hasGalleryOption) {
      const value = selectedOptions()[galleryOptionIndex];
      const match = variants.find(
        (candidate) =>
          candidate.options[galleryOptionIndex] === value &&
          candidate.featured_media_id
      );
      return match ? match.featured_media_id : null;
    }
    return variant ? variant.featured_media_id : null;
  }

  // "COLOR: ORANGE / BLUE" style labels, one per option that has one.
  function updateSelectedLabels() {
    const options = selectedOptions();
    product
      .querySelectorAll('[data-option-selected]')
      .forEach((label) => {
        const index = parseInt(
          label.getAttribute('data-option-selected'),
          10
        );
        if (options[index] !== undefined) label.textContent = options[index];
      });
  }

  function updateForVariant(scrollBehavior) {
  const variant = findVariant(selectedOptions());

  updateSelectedLabels();
  scrollToSlide(
    slideIndexForMedia(mediaIdForSelection(variant)),
    scrollBehavior
  );

  if (!variant) {
    if (addButton) addButton.disabled = true;

    if (addButtonText) {
      addButtonText.textContent =
        window.themeStrings.unavailable || 'Unavailable';
    }

    return;
  }

  if (variantIdInput) {
    variantIdInput.value = variant.id;
  }

  if (addButton && addButtonText) {
    if (variant.available === false) {
      addButton.disabled = true;
      addButtonText.textContent =
        window.themeStrings.soldOut || 'Sold Out';
    } else if (variant.preorder === true) {
      addButton.disabled = false;
      addButtonText.textContent = 'PRE-ORDER';
    } else {
      addButton.disabled = false;
      addButtonText.textContent =
        window.themeStrings.addToCart || 'Add to Cart';
    }
  }

  if (priceCurrent) {
    priceCurrent.textContent =
      window.themeFormatMoney(variant.price);
  }
}

  product
    .querySelectorAll('.product-option-input')
    .forEach((input) => {
      input.addEventListener('change', () => updateForVariant());
    });

  // Swiping the gallery to another colorway picks that colour. Runs once the
  // scroll has settled; a no-op when the slide's colour is already selected,
  // which is what stops a picked colour's own scroll from feeding back.
  if (galleryTrack && hasGalleryOption) {
    let settleTimer = null;
    galleryTrack.addEventListener(
      'scroll',
      () => {
        window.clearTimeout(settleTimer);
        settleTimer = window.setTimeout(() => {
          const slide = gallerySlides[currentSlideIndex()];
          if (!slide) return;
          const mediaId = slide.getAttribute('data-media-id');
          const match = variants.find(
            (candidate) => String(candidate.featured_media_id) === mediaId
          );
          if (!match) return;
          const value = match.options[galleryOptionIndex];
          if (selectedOptions()[galleryOptionIndex] === value) return;
          const input = Array.from(
            product.querySelectorAll(
              `.product-option-input[data-option-value="${galleryOptionIndex}"]`
            )
          ).find((candidate) => candidate.value === value);
          if (!input || input.checked) return;
          input.checked = true;
          updateForVariant();
        }, 120);
      },
      { passive: true }
    );
  }

  // Arrows step through the slides, wrapping at either end.
  const galleryPrev = product.querySelector('[data-gallery-prev]');
  const galleryNext = product.querySelector('[data-gallery-next]');
  const stepGallery = (delta) => {
    const count = gallerySlides.length;
    if (count < 2) return;
    const current = currentSlideIndex();
    scrollToSlide((current + delta + count) % count);
  };
  if (galleryPrev) galleryPrev.addEventListener('click', () => stepGallery(-1));
  if (galleryNext) galleryNext.addEventListener('click', () => stepGallery(1));

  // Set the correct text (and land on the selected colorway) when the page
  // first loads.
  updateForVariant('auto');

  // Quantity controls
  const quantityInput = product.querySelector(
    '[data-quantity-input]'
  );
  const quantityMinus = product.querySelector(
    '[data-quantity-minus]'
  );
  const quantityPlus = product.querySelector(
    '[data-quantity-plus]'
  );

  if (quantityInput) {
    const min = parseInt(quantityInput.min, 10) || 1;

    const syncMinus = () => {
      const current =
        parseInt(quantityInput.value, 10) || min;

      if (quantityMinus) {
        quantityMinus.disabled = current <= min;
      }
    };

    const stepQuantity = (delta) => {
      const current =
        parseInt(quantityInput.value, 10) || min;

      quantityInput.value = Math.max(
        min,
        current + delta
      );

      syncMinus();
    };

    if (quantityMinus) {
      quantityMinus.addEventListener('click', () =>
        stepQuantity(-1)
      );
    }

    if (quantityPlus) {
      quantityPlus.addEventListener('click', () =>
        stepQuantity(1)
      );
    }

    syncMinus();
  }

  if (form && addButton) {
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      addButton.disabled = true;

      try {
        const body = new FormData(form);

        await fetch(
          `${window.Shopify.routes.root}cart/add.js`,
          {
            method: 'POST',
            body,
          }
        );

        await Promise.all([
          refreshCartDrawer(),
          refreshCartCount(),
        ]);

        openCartDrawer();
      } finally {
        // Restore the correct state and wording.
        updateForVariant();
      }
    });
  }
}

initProductForm();
